// extracted by mini-css-extract-plugin
export default {"error":"InputWrapper_error__wgrRE"};